import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const textBoxVariants = cva(
  "flex flex-row justify-start border-[1px] border-black p-1 shadow-basic",
  {
    variants: {
      variant: {
        primary: "bg-night-primary",
      },
      size: {
        lg: "text-lg p-1",
      },
      spacing: {
        base: "ml-8",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "lg",
      spacing: "base",
    },
  }
);

interface TextBoxProps extends VariantProps<typeof textBoxVariants> {
  className?: string;
  children: React.ReactNode;
  textClassName?: string;
}

export const TextBox = ({
  variant,
  size,
  spacing,
  className,
  children,
  textClassName,
  ...props
}: TextBoxProps) => {
  return (
    <div
      className={cn(textBoxVariants({ variant, size, spacing }), className)}
      {...props}
    >
      <div className={cn("pl-4 text-left", textClassName)}>{children}</div>
    </div>
  );
};
